module.exports = __webpack_public_path__ + "static/media/COS_PIERRE_FABRE_DERMO_COSMETIQUE.60eb5b8a.png";